module.exports = __webpack_public_path__ + "static/media/map.055e99c0.png";